import script from "./MappedCampaigns.vue?vue&type=script&setup=true&lang=js"
export * from "./MappedCampaigns.vue?vue&type=script&setup=true&lang=js"

import "./MappedCampaigns.vue?vue&type=style&index=0&id=8733414a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-8733414a"]])

export default __exports__